<template>
<div class="chapter">
<div class="inner_page">
<p class="copy1"><a id="ch00_fm04_copy"></a><a id="page_iv"></a>NEW YORK UNIVERSITY PRESS</p>
<p class="copy">New York and London</p>
<p class="copy"><span class="weblink"><a class="nounder" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></span></p>
<p class="copy1">© 2012 by New York University</p>
<p class="copy">All rights reserved</p>
<p class="copy1">References to Internet websites (URLs) were accurate at the time of writing.</p>
<p class="copy">Neither the author nor New York University Press is responsible for URLs</p>
<p class="copy">that may have expired or changed since the manuscript was prepared.</p>
<p class="copy1">Library of Congress Cataloging-in-Publication Data</p>
<p class="copy">Hughes, Michael J., 1972-</p>
<p class="copy">Forging Napoleon’s Grande Armée : motivation, military culture, and masculinity in the</p>
<p class="copy">French army, 1800-1808 / Michael J. Hughes.</p>
<p class="copy">p. cm. — (Warfare and culture series)</p>
<p class="copy">Includes bibliographical references and index.</p>
<p class="copy">ISBN 978-0-8147-3748-4 (cl : alk. paper)</p>
<p class="copy">ISBN 978-0-8147-0827-9 (ebook)</p>
<p class="copy">ISBN 978-0-8147-2411-8 (ebook)</p>
<p class="copy">1. France. Armée. Grande Armée — History.</p>
<p class="copy">2. France. Armée. Grande Armée — Military life.</p>
<p class="copy">3. Soldiers — Attitudes — France — History — 19th century.</p>
<p class="copy">4. Masculinity — France — History — 19th century.</p>
<p class="copy">5. Military morale — France — History — 19th century.</p>
<p class="copy">6. Sociology, Military — France — History — 19th century.</p>
<p class="copy">7. Napoleon I, Emperor of the French, 1769-1821 — Military leadership.</p>
<p class="copy">8. Napoleonic Wars, 1800-1815.</p>
<p class="copy">9. France — History, Military — 1789-1815. I. Title.</p>
<p class="copy">DC202.1.H84 2012</p>
<p class="copy">940.2’7420944 — dc23</p>
<p class="attribution">2011050070</p>
<p class="copy1">New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability. We strive to use environmentally responsible suppliers and materials to the greatest extent possible in publishing our books.</p>
<p class="copy1">Manufactured in the United States of America</p>
<p class="copy">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_copy.vue?6f633f75